import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		locale: 'id'
	},
	getters: {
        GetLocale: state => {
			return state.locale;
		}
	},
	mutations: {
		SetLocale: function(state){
			state.locale = 'en';
		}
	},
	actions: {
		UpdateLocale: function(context){
			context.commit('SetLocale')
		}
	}
})